/**
 * @description 對應險種類別名稱用
 */
export enum InsTypeName {
  All='全部',
  Travel= '旅遊險',
  Car='汽車險',
  Moto='機車險',
  Fire='住宅火險',
  MobileDevice = '行動電話險',
  Pet='寵物險',
  ECar='電車險',
  Emoto='微型二輪電動車'
}
